export default {
  // baseUrl: 'https://cia.netizens.pl',
  // apiUrl: 'https://cia.netizens.pl',
  // baseUrl: 'http://cia.cm.netizens.pl',
  // apiUrl: 'http://cia.cm.netizens.pl',
  baseUrl: 'https://www.centruminnowacyjnejarchiwizacji.pl',
  apiUrl: 'https://api.centruminnowacyjnejarchiwizacji.pl',
  fileUpload: {
    maxChunkSize: 5000000, // 5mb
    maxNumberOfFiles: 100,
    maxFileSize: 512000000, // 512MB
    acceptFileTypes: /(\.|\/)(aac|abw|arc|avi|azw|bin|bmp|bz|bz2|csh|css|csv|doc|docx|eot|epub|es|gif|htm|html|ico|ics|jar|jpeg|jpg|json|mid|midi|mpeg|mpkg|odp|ods|odt|oga|ogv|ogx|otf|png|pdf|ppt|pptx|rar|rtf|svg|swf|tar|tif|tiff|ttf|txt|vsd|wav|weba|webm|webp|woff|woff2|xhtml|xls|xlsx|xml|xul|zip|dscan|mscan|tscan|hcmd|sproj|hist)$/i,
  },
  publicRoutes: [
    'reset-password',
    'recive-password',
    'login',
    'login-unblock',
    'LandingPage',
    'Regulations',
    'PrivacyPolicy',
    'PageNotFound',
    'Donation',
  ],
  accountExpirationNotifyDays: 14, // na ile dni przed wygasnieciem konta pojawia sie ostrzezenie
  maxAttempts: 5,
};
